module.exports = __webpack_public_path__ + "static/media/reset-pwd-bottom-right-ellipse.bb22ff5a.png";